// extracted by mini-css-extract-plugin
module.exports = {"empty":"empty--NRAIy","emptyTitle":"emptyTitle--TBLiE","emptyCapture":"emptyCapture--dssiI","emptySubtitle":"emptySubtitle--EvC3v"};